
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { BoardIVO, BoardOVO, BoardReplyOVO} from '@/views/biz/board/vo/BoardVO'
import { CommonCodeIVO, CommonCodeOVO } from '@/views/bizcommon/code/vo/CodeVO.vo'
import { MemberVO } from '@/views/biz/login/vo/MemberVO.vo'
import BasicBoard from '@/components/BasicBoard.vue'
import Constants from '@/constants'
import CommonUtils from '@/common-utils'
import axios from 'axios'

@Component({
  components: {BasicBoard}
})
export default class Board extends Vue {
  @Prop() tabCode !: string;
  diff: BoardOVO = {} as BoardOVO;
  boardTabs = [] as Array<CommonCodeOVO>;
  code = '' as string;

  get getTabCode() {
    return !this.tabCode ? this.boardTabs[0].codeNo: this.tabCode;
  }

  created(): void {
    axios.get('board/tabs')
    .then(r=>{
      this.boardTabs = r.data;
    })
  }
}
